import { NgModule, SecurityContext } from '@angular/core';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRippleModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatGridListModule } from '@angular/material/grid-list';

import { DragDropModule } from '@angular/cdk/drag-drop';


import { DomSanitizer } from '@angular/platform-browser';

const materialModules = [
  MatAutocompleteModule,
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDividerModule,
  MatExpansionModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatProgressSpinnerModule,
  MatPaginatorModule,
  MatRippleModule,
  MatSelectModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatFormFieldModule,
  MatDatepickerModule,
  MatTooltipModule,
  MatDialogModule,
  MatGridListModule,
  MatMomentDateModule,
  DragDropModule,
];

export const locale = window.navigator.language || 'en-EN';

@NgModule({
  declarations: [],
  imports: [
    ...materialModules
  ],
  exports: [
    ...materialModules
  ],
  providers: [
    // { provide: MAT_LUXON_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } }
  ]
})
export class MaterialModule {

  constructor(mdIconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    mdIconRegistry.addSvgIcon('16px_account_tree', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_account_tree.svg'));
    mdIconRegistry.addSvgIcon('16px_factory', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_factory.svg'));
    mdIconRegistry.addSvgIcon('16px_home', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_home.svg'));
    mdIconRegistry.addSvgIcon('16px_cip', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_CIP.svg'));
    mdIconRegistry.addSvgIcon('16px_chemical', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_Chemical.svg'));
    mdIconRegistry.addSvgIcon('16px_consumption', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_Consumption.svg'));
    mdIconRegistry.addSvgIcon('16px_downtime', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_Downtime.svg'));
    mdIconRegistry.addSvgIcon('16px_error', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_Error.svg'));
    mdIconRegistry.addSvgIcon('16px_fluxtest', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_Fluxtest.svg'));
    mdIconRegistry.addSvgIcon('16px_membrane', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_Membrane.svg'));
    mdIconRegistry.addSvgIcon('16px_select_check_box', sanitizer.bypassSecurityTrustResourceUrl('assets/icons/16px_Select_check_box.svg'));
  }

}
